import { DropdownButton, Dropdown } from "react-bootstrap";

export default function AccountingReportSelector({ value = "", onChange }) {
  const textValue = () => {
    return `Accounts ${value === "advertiser" ? "Receivable" : "Payable"}`;
  };

  const onClick = (report) => {
    if (onChange) {
      onChange(report);
    }
  };

  return (
    <div className="standard-dropdown">
      <div className="standard-dropdown-label">Report:</div>
      <DropdownButton title={textValue()}>
        <Dropdown.Item onClick={() => onClick("advertiser")} as="button">
          Accounts Receivable
        </Dropdown.Item>
        <Dropdown.Item onClick={() => onClick("customer")} as="button">
          Accounts Payable
        </Dropdown.Item>
      </DropdownButton>
    </div>
  );
}
